import React from 'react'
import SearchSection from '../../components/HeroSection/SearchSection'

const MappingHome = () => {
  return (
    <>
      <SearchSection />
    </>
  )
}

export default MappingHome